import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const DropdownArrowDownIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="20" height="20" rx="4" fill="#212121" />
        <path
          d="M6.58096 7.5C5.69006 7.5 5.24389 8.57714 5.87385 9.20711L9.29297 12.6262C9.6835 13.0168 10.3167 13.0168 10.7072 12.6262L14.1263 9.20711C14.7563 8.57714 14.3101 7.5 13.4192 7.5L6.58096 7.5Z"
          fill="white"
        />
      </svg>
    )
  },
)
